// =============================================================================
// AssignedElsewhere.jsx
// =============================================================================
// Shown when a request / Sales Order is assigned to ANOTHER same-role worker.
// A UI ownership gate (not an RLS boundary): a peer Responder/Picker may not open
// a task held by someone else; a Supervisor+ may, and sees the softer notice.
//
// Two modes on one component:
//   blocked (default true) → full card that REPLACES the request content
//                            ("only a supervisor can open this")
//   blocked={false}        → slim inline notice (content still renders beneath it)
//
// Props
// ─────
//   req      — request object (read for refNo, for the blocked-card heading)
//   name     — the assignee's display name (may be empty)
//   blocked  — true = blocking card; false = supervisor notice banner
// =============================================================================
import { GLYPH } from "../../utils/glyphs";
import { formatRef } from "../../utils/helpers";

export function AssignedElsewhere({ req, name, blocked = true }) {
  const who = name || "another team member";
  if (!blocked) {
    return (
      <div
        style={{
          background: "#FFF8E1",
          border: "1px solid #FFB300",
          borderRadius: 8,
          padding: "8px 14px",
          marginBottom: 14,
          fontSize: 13,
          fontWeight: 600,
          color: "#795548",
        }}
      >
        {GLYPH.lock} Assigned to {who} — you are viewing as a supervisor.
      </div>
    );
  }
  return (
    <div>
      <h1 style={{ margin: "0 0 16px", fontSize: 22, color: "#1A2E2B" }}>
        {`Request ${formatRef(req?.refNo)}`}
      </h1>
      <div
        style={{
          background: "#FFF8E1",
          border: "2px solid #FFB300",
          borderRadius: 12,
          padding: "28px 32px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 22, marginBottom: 8 }}>{GLYPH.lock}</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#E65100", marginBottom: 6 }}>
          This is assigned to {who}
        </div>
        <div style={{ fontSize: 13, color: "#795548" }}>
          Only a supervisor can open something that is assigned to someone else. Ask {who} or a
          supervisor if you need to work on it.
        </div>
      </div>
    </div>
  );
}
